// Pass 2.12 — small "Reset layout" button. Sits in TopNav's
// rightSlot and triggers the caller's onClick, which calls
// useLayoutState's resetLayout to clear storage + restore
// defaults. Stateless wrapper so the test surface is just
// "renders + click fires onClick".

import { Maximize2 } from "lucide-react";

interface ResetLayoutButtonProps {
  onClick: () => void;
}

export function ResetLayoutButton({ onClick }: ResetLayoutButtonProps) {
  return (
    <button
      type="button"
      data-testid="reset-layout"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.1] text-[12px] font-medium text-theme-text-secondary hover:text-theme-text-primary hover:border-white/[0.2] transition-colors duration-150"
      title="Reset pane sizes to defaults"
    >
      <Maximize2 className="w-3 h-3" strokeWidth={1.5} aria-hidden />
      Reset layout
    </button>
  );
}
